import type { ImageType } from "~/components/common/images";
import Image from "~/components/common/images";
import KonnectButton from "~/components/common/KonnectButton/KonnectButton";

export interface FeaturesSectionProps {
  id: string;
  type: string;
  title: string;
  items: {
    title: string;
    icon: {
      url: string;
    };
    image?: ImageType;
    list: {
      text: string;
      id: string;
    }[];
    button?: {
      text: string;
      url: string;
    };
    subtitle?: string;
  }[];
}

const FeaturesSection = ({ type, title, items }: FeaturesSectionProps) => (
  <section
    id={type}
    className="section-padding-x flex flex-col items-center py-[50px] md:py-[100px]"
  >
    <h2 className="h2 mb-[20px] text-center font-semibold text-charcoal lg:mb-[118px]">
      {title}
    </h2>
    {items.map((item) => (
      <div
        key={item.title}
        className="flex flex-col items-start justify-between py-[50px] md:flex-row"
      >
        <div className="w-full md:w-1/2 md:max-w-[400px] lg:pt-[44px]">
          <div className="mb-[30px] flex">
            <div className="">
              <h3 className="text-lg font-medium text-charcoal">
                {item.title}
              </h3>
              {item.subtitle && (
                <span className="text-md text-charcoal">{item.subtitle}</span>
              )}
            </div>
          </div>
          <ul className="ml-[30px] list-disc">
            {item.list.map((listItem) => (
              <li key={listItem.id} className="mb-[1em] text-md">
                {listItem.text}
              </li>
            ))}
          </ul>
          {item.button && (
            <KonnectButton
              text={item.button.text}
              textColor="white"
              bgColor="charcoal"
              hoverBgColor="purple/80"
              className="mt-[30px]"
            />
          )}
        </div>
        <div className="relative mt-[30px] w-full overflow-hidden rounded-lg md:ml-[11px] md:mt-0 md:w-1/2">
          {item.image && (
            <Image
              image={item.image}
              alt={item.title}
              maxWidth={1000}
              className="size-full object-fill"
            />
          )}
        </div>
      </div>
    ))}
  </section>
);

export default FeaturesSection;
